import * as React from 'react';
import { Growl } from 'primereact/growl';

let growl: Growl | null = null;
export const Growler = growl;

const GrowlContext = React.createContext<Growl|null>(null);
export default GrowlContext;